import { DEBUG_INIT_LOADING, DEBUG_INIT_SUCCESS, DEBUG_INIT_FAIL } from '@/store/types'

export const mutations = {
  [DEBUG_INIT_LOADING](state) {
    state.debug.init = 0
  },
  [DEBUG_INIT_SUCCESS](state, data) {
    state.debug.menu = data.menu
    state.debug.init = 1
  },
  [DEBUG_INIT_FAIL](state) {
    state.debug.init = 2
  }
}
